var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplainerSurveillance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88045 13.6368L19.5 5.7735L33.1195 13.6368V29.3632L19.5 37.2265L5.88045 29.3632V13.6368Z",
    fill: "#100F2E",
    stroke: "#100F2E",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H19V23.725L22 25.45L23 23.725L20 22L23 20.275L22 18.55L19 20.275V17H17V20.275L14 18.55L13 20.275L16 22L13 23.725L14 25.45L17 23.725V27ZM12 30C11.45 30 10.9792 29.8042 10.5875 29.4125C10.1958 29.0208 10 28.55 10 28V16C10 15.45 10.1958 14.9792 10.5875 14.5875C10.9792 14.1958 11.45 14 12 14H24C24.55 14 25.0208 14.1958 25.4125 14.5875C25.8042 14.9792 26 15.45 26 16V20.5L30 16.5V27.5L26 23.5V28C26 28.55 25.8042 29.0208 25.4125 29.4125C25.0208 29.8042 24.55 30 24 30H12ZM12 28H24V16H12V28Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainerSurveillance);
export default __webpack_public_path__ + "static/media/explainer-surveillance.800bad0f4189515e5cf63167c386c1a4.svg";
export { ForwardRef as ReactComponent };